import { useQuery } from 'react-query';
import { getVoiceChatInfo } from 'src/api/voiceChatApi';

export function useGetVoiceChatInfo(chatId: string) {
  const { data, isSuccess } = useQuery('GetVoiceInfo', () => getVoiceChatInfo(chatId))

  return { data, isSuccess }
}
